<!-- <app-data-table [columns]="cols" [data]="equipment" [title]="title"></app-data-table> -->
<ng-container>

  <app-data-table [columns]="cols" [data]="equipments" [isCardView]="false" [url]="'/master/equipment-master/'"
    [isDeletable]="'/master/equipment' | hasPermission: 'Delete'"  [isView]="'/master/equipment' | hasPermission: 'View'" (viewEventRow)="viewSystem($event)" 
    [showAddButton]="'/master/equipment' | hasPermission: 'Add'" [showActions]="canEditSetup"
    [isEditable]="'/master/equipment' | hasPermission: 'Edit'" (onPresentView)=" getSystem()" [title]="title"
    (onAdd)="addEquipment()" (editEventRow)="updateEquipment($event)" (deleteEventRow)="showDeletePopup($event)"
    (onLazyLoadData)="getSystem($event)" [totalRecords]="totalRecords">
  </app-data-table>
</ng-container>


<!-- Create Equipment Dialog -->
<app-reusable-dialog
  [(visible)]="showDialog"
  [config]="createDialogConfig"
  [initialData]="initialData"
  [viewMode]="false"
  (onSubmit)="onCreateSubmit($event)"
  (onCancel)="onDialogCancel()"
  (onClose)="onDialogClose()"
></app-reusable-dialog>

<!-- Update/View Equipment Dialog -->
<app-reusable-dialog
  [(visible)]="isUpdatedialog"
  [config]="updateDialogConfig"
  [initialData]="initialData"
  [viewMode]="viewMode"
  (onSubmit)="onUpdateSubmit($event)"
  (onCancel)="onDialogCancel()"
  (onClose)="onDialogClose()"
></app-reusable-dialog>

<p-dialog header="Delete Equipment" [modal]="true" [(visible)]="showDeleteDialog" [style]="{ width: '30rem' }" [maximizable]="true">
  <div class="delete-dialog text-center mt-3">
    <i class="pi pi-trash text-danger custom-delete-icon"></i>
    <p>Are you sure you want to delete this equipment?</p>

    <p-button label="Delete" icon="pi pi-trash" severity="danger" [outlined]="true" (click)="deleteequipment()" class="mt-2">
    </p-button>
  </div>
</p-dialog>
